import { BaseQueryParams, DynamicForm, DynamicFormDto, IResponse, IResponsePaginate, WithMetadata } from '@/types';
import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

interface DynamicFormQuery extends BaseQueryParams {
  code?: string;
  description?: string;
  search?: string;
  page?: number;
  size?: number;
}

@Injectable({
  providedIn: 'root',
})
export class DynamicFormsService {
  BASEURL = `${environment.api.paramsUrl}/dyna-forms`;
  httpClient = inject(HttpClient);

  getPaginatedDynamicForms(params?: DynamicFormQuery): Observable<IResponsePaginate<DynamicForm>> {
    return this.httpClient.get<IResponsePaginate<any>>(`${this.BASEURL}`, { params: params as HttpParams });
  }

  getDynamicForm(id: number): Observable<WithMetadata<DynamicForm>> {
    return this.httpClient.get<WithMetadata<DynamicForm>>(`${this.BASEURL}/${id}/latest`);
  }

  addDynamicForm(form: DynamicFormDto): Observable<IResponse<DynamicForm>> {
    return this.httpClient.post<IResponse<DynamicForm>>(`${this.BASEURL}`, form);
  }

  updateDynamicForm(id: number, form: DynamicFormDto): Observable<IResponse<DynamicForm>> {
    return this.httpClient.put<IResponse<DynamicForm>>(`${this.BASEURL}/${id}/versioning`, form);
  }

  deleteDynamicForm(id: number): Observable<IResponse<DynamicForm>> {
    return this.httpClient.delete<IResponse<DynamicForm>>(`${this.BASEURL}/${id}`);
  }
}
